var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1152 11.3393L13.4806 9.70396C13.3065 9.52958 13.0998 9.39123 12.8722 9.29684C12.6446 9.20245 12.4006 9.15386 12.1542 9.15386C11.9078 9.15386 11.6639 9.20245 11.4363 9.29684C11.2087 9.39123 11.002 9.52958 10.8279 9.70396L10.4946 10.0373C8.85172 8.66079 7.33422 7.14128 5.95989 5.49663L6.29323 5.16329C6.64423 4.81126 6.84134 4.33442 6.84134 3.83729C6.84134 3.34017 6.64423 2.86333 6.29323 2.51129L4.65523 0.87796C4.29763 0.536337 3.82211 0.345703 3.32756 0.345703C2.83301 0.345703 2.35749 0.536337 1.99989 0.87796L1.10656 1.77529C0.677283 2.20766 0.409842 2.77457 0.349144 3.38081C0.288447 3.98706 0.438189 4.59574 0.773227 5.10463C3.43662 9.11785 6.87587 12.5578 10.8886 15.222C11.3992 15.5539 12.0078 15.7018 12.6138 15.6412C13.2199 15.5806 13.7871 15.3151 14.2219 14.8886L15.1186 13.9913C15.2929 13.8173 15.4312 13.6107 15.5256 13.3832C15.62 13.1558 15.6685 12.9119 15.6685 12.6656C15.6685 12.4194 15.62 12.1755 15.5256 11.948C15.4312 11.7205 15.2929 11.5139 15.1186 11.34L15.1152 11.3393Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c0526edbb71d597be46c650d122d8af1.svg";
export { ForwardRef as ReactComponent };